type SwitchToggleProps = {
	disabled?: boolean;
	isOn: boolean;
	onChange: (value: boolean) => void;
};

const SwitchToggle = ({
	disabled = false,
	isOn,
	onChange,
}: SwitchToggleProps) => {
	return (
		<button
			type="button"
			role="switch"
			aria-checked={isOn}
			disabled={disabled}
			onClick={() => onChange(!isOn)}
			className={`relative flex h-5 w-9 shrink-0 items-center rounded-full p-0.5 transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${isOn ? 'bg-mantang-primary' : 'bg-mantang-gray-100'} ${disabled ? '' : 'cursor-pointer'}`}
		>
			<span
				className={`size-4 rounded-full bg-white shadow-sm transition-transform ${isOn ? 'translate-x-4' : 'translate-x-0'}`}
			/>
		</button>
	);
};

export default SwitchToggle;
